import React from 'react';

const PlacementsSection = () => {
  return (
    <div className="relative bg-[#1D1A55] text-white py-4 md:py-0 lg:flex lg:items-center">
      <div className="mx-auto md:flex justify-between px-4 md:pr-8 md:pl-0">
        {/* Left Side - Image */}
        <div className="lg:w-1/4 w-full">
          <img
            src="assets/explore.jpeg"
            alt="Students in Placement"
            className="shadow-lg w-full h-auto"
          />
        </div>

        {/* Right Side - Content */}
        <div className="lg:w-3/4 lg:pl-12 text-center lg:text-left mt-8 pt-7 lg:mt-0">
          <div className="flex mb-8 justify-center md:justify-normal">
            <h2 className="text-3xl md:text-4xl font-bold text-white  border-b-[3px] border-white py-1">
              Recruitment Insights
            </h2>
          </div>
          <h2 className="text-2xl md:text-3xl font-semibold mb-4">
            Explore Our Placement Opportunities:
          </h2>
          <p className="text-lg text-gray-200 mb-6">
            At SPSU University, we are committed to bridging the gap between
            education and industry. Our dedicated placement cell works
            tirelessly to provide students with a variety of placement
            opportunities that align with their skills and aspirations.
          </p>

          {/* Placement Opportunity Icons */}
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img src="assets/placement/1.png" alt="Diverse Industries" />
              </div>
              <p className="text-xl font-semibold">Diverse Industries</p>
            </div>

            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img src="assets/placement/2.png" alt="Top Recruiters" />
              </div>
              <p className="text-xl font-semibold">Top Recruiters</p>
            </div>

            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img
                  src="assets/placement/3.png"
                  alt="Internship Opportunities"
                />
              </div>
              <p className="text-xl font-semibold">Internship Opportunities</p>
            </div>

            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img src="assets/placement/4.png" alt="Skill Development" />
              </div>
              <p className="text-xl font-semibold">
                Skill Development Programs
              </p>
            </div>
          </div> */}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((item, index) => {
              const icons = [
                { src: '1.png', label: 'Diverse Industries' },
                { src: '2.png', label: 'Top Recruiters' },
                { src: '3.png', label: 'Internship Opportunities' },
                { src: '4.png', label: 'Skill Development Programs' },
              ];

              return (
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center">
                    <img
                      src={`assets/placement/${icons[index].src}`}
                      alt={icons[index].label}
                    />
                  </div>
                  <p className="text-xl font-semibold">{icons[index].label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlacementsSection;
